import { SalaryType } from "../orders/types/salaryType";
import {
  TesSalaryTableCell,
  TesSalaryTableColumn,
  TesSalaryTableDocument,
  TesSalaryTableRow,
} from "./tesSalaryTablesApi";

export const sortTesSalaryTableRows = (rows: TesSalaryTableRow[]) =>
  [...rows].sort((a, b) => a.sortOrder - b.sortOrder);

export const sortTesSalaryTableColumns = (columns: TesSalaryTableColumn[]) =>
  [...columns].sort((a, b) => a.sortOrder - b.sortOrder);

export const getTesSalaryTableCell = (
  table: TesSalaryTableDocument | null | undefined,
  rowId: string,
  columnId: string,
) =>
  table?.cells.find(
    (cell) => cell.rowId === rowId && cell.columnId === columnId,
  );

export const getTesSalaryTableRow = (
  table: TesSalaryTableDocument | null | undefined,
  rowId: string,
) => table?.rows.find((row) => row.rowId === rowId);

export const getTesSalaryTableColumn = (
  table: TesSalaryTableDocument | null | undefined,
  columnId: string,
) => table?.columns.find((column) => column.columnId === columnId);

export const formatTesSalaryCellValue = (
  cell: TesSalaryTableCell | null | undefined,
  salaryType?: SalaryType,
) => {
  if (!cell) return "-";
  if (salaryType === SalaryType.Hourly) {
    return cell.hourlySalary ? `${cell.hourlySalary} EUR/h` : "-";
  }
  if (salaryType === SalaryType.Monthly) {
    return cell.monthlySalary ? `${cell.monthlySalary} EUR/mo` : "-";
  }
  if (cell.hourlySalary) return `${cell.hourlySalary} EUR/h`;
  if (cell.monthlySalary) return `${cell.monthlySalary} EUR/mo`;
  return "-";
};

export const getSalaryAmountFromCell = (
  cell: TesSalaryTableCell | null | undefined,
  salaryType: SalaryType,
) =>
  (salaryType === SalaryType.Monthly
    ? cell?.monthlySalary
    : cell?.hourlySalary) || "";
